var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar',{attrs:{"data":_vm.data,"logo-url":"","logo-src":"","logo-icon-src":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }